import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PersonProjectRequest } from '@app/models/project-setup.models';
import { PersonRoleType } from '@app/models/shared.enums';
import {
  getTitleNameFormGroup,
  getTitleNameFormGroupFromPersonRequest,
  TitleNameFormGroup,
} from '../title-name-form/title-name-form.helper';

export interface GuarantorFormGroup {
  connectionTypeCode: FormControl<PersonRoleType | null>;
  titleNameForm: FormGroup<TitleNameFormGroup>;
  formOfConnection: FormControl<string | null>;
}

export function getGuarantorFormGroup(
  fb: FormBuilder,
  personRoleCode: PersonRoleType | null = null
): FormGroup<GuarantorFormGroup> {
  return fb.nonNullable.group({
    connectionTypeCode: fb.control<PersonRoleType | null>(personRoleCode),
    titleNameForm: getTitleNameFormGroup(fb),
    formOfConnection: fb.control<string | null>(null),
  });
}

export function getGuarantorFormGroupFromPersonProjectRequest(
  fb: FormBuilder,
  personProjectRequest: PersonProjectRequest,
  personRoleCode: PersonRoleType
): FormGroup<GuarantorFormGroup> {
  const group = fb.nonNullable.group({
    connectionTypeCode: fb.control<PersonRoleType | null>(personRoleCode),
    titleNameForm: getTitleNameFormGroupFromPersonRequest(
      fb,
      false,
      personProjectRequest.person,
      personRoleCode
    ),
    formOfConnection: fb.control<string | null>(null),
  });
  if (personProjectRequest.connectionTypeCode) {
    group.controls.formOfConnection.setValue(
      personProjectRequest.connectionTypeCode,
      { emitEvent: false }
    );
  }
  return group;
}

export function getPersonProjectRequestFromGuarantorFormValue(
  formValue: FormGroup<GuarantorFormGroup>
): PersonProjectRequest {
  const connectionId = formValue.controls.formOfConnection.value;
  return {
    connectionTypeCode: connectionId ?? formValue.controls.connectionTypeCode.value,
    description: null,
    person: {
      titleCode: null,
      firstName:
        formValue.controls.titleNameForm.controls.name.controls.firstName
          .value!,
      midName:
        formValue.controls.titleNameForm.controls.name.controls.middleName
          .value,
      lastName:
        formValue.controls.titleNameForm.controls.name.controls.lastName.value!,
      email: null,
      birthDate: null,
      birthPlace: null,
      citizenship: null,
      idCardNumber: null,
      idCardNumberExpiry: null,
      idCardType: null,
      motherFirstName: null,
      motherLastName: null,
      motherMidName: null,
      maidenFirstName: null,
      maidenLastName: null,
      maidenMidName: null,
      taxIdentifier: null,
      address: null,
      position: null,
      bankAccountNumber: null,
    },
  };
}
